import React, { useEffect, useState } from "react";
import styles from "./Edufin.module.css";
import { Box, Button, Grid, InputLabel } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router";
import nurturePayImg from "../Assets/npayimg.svg";
import nurturePayLogo from "../Assets/npaylogo.svg";
import edufinLogo from "../../../../../assets/images/edufinLogo.svg";
import instituteDetailsImg from "../../../../../assets/images/instDetails.svg";
import activatedCourseDetails from "../../../../../assets/images/activatedCourseDetails.svg";
import courseDetails from "../../../../../assets/images/courseDetails.svg";
import NewFormTextInput from "../../../../../components/FormTextInput/NewFormTextInput";
import AutoCompleteField from "../../../../../components/AutoCompleteField/AutoCompleteField";
import CountryCodePhoneInput from "../../../../../components/CountryCodePhoneInput/CountryCodePhoneInput";
import SaveBtn from "../../../../../components/Buttons/SaveBtn";
import InstituteDetailsForEdufin from "./InstituteDetailsForEdufin";
import CourseDetailsForEdufin from "./CourseDetailsForEdufin";
import Line from "../../../../../assets/images/Line.svg";
import { useAuthUser } from "react-auth-kit";
import Inactive from "../../../../../assets/images/edufinInactive.svg";
import Active from "../../../../../assets/images/edufinActive.svg";
import { toggleTrigger } from "../../../Main/service/submerchantBranchUpdationSlice";
import { useDispatch } from "react-redux";

function EdufinDetails(props: any) {
  const navigate = useNavigate();
  const [showIndex, setShowIndex] = useState(0);
  const {
    SaveEdufinData,
    GetEdufinData,
    edufinData,
    saveEdufinSuccess,
    edufinDataLoading,
    saveEdufinData,
  } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const [instituteInfo, setInstituteInfo] = useState<any>({
    instituteName: "",
    // branchId: "",
    // branchName: "",
    branches: [],
    address: "",
    city: "",
    state: "",
    pincode: "",
    operationSince: "",
    averageFees: "",
    studentStrength: "",
    teacherStrength: "",
    affiliationCode: "",
    instituteType: "",
    board: "",
  });
  const [contactInfo, setContactInfo] = useState<any>({
    principalName: "",
    principalNumber: "",
    spocPersonName: "",
    spocPersonNumber: "",
    spocPersonEmail: "",
    accountEmail: "",
  });
  const [bankInfo, setBankInfo] = useState<any>({
    bankName: "",
    bankAccountNumber: "",
    ifscCode: "",
    accountType: "",
    beneficiaryName: "",
    website: "",
  });
  const [courses, setCourses] = useState([
    {
      id: 0,
      courseName: "",
      courseStartYear: "",
      duration: "",
      noOfStudents: "",
      tutionFees: "",
      transportFees: "",
      otherFees: "",
      totalFees: "",
    },
  ]);
  const [instituteInfoForCourse, setInstituteInfoForCourse] = useState<any>({
    instituteName: "",
    instituteType: "",
  });
  const dispatch = useDispatch();
  const instituteDetails = authUser?.institute?.[0]?.instituteDetails;

  const urlSearchParams = new URLSearchParams(window.location.search);
  const id = localStorage.getItem("idForEdufinForm");

  useEffect(() => {
    dispatch(toggleTrigger());
    if (instituteDetails?.id && id) {
      const body = {
        instituteId: instituteDetails.id,
        id: id,
      };
      GetEdufinData(body);
    }
  }, [instituteDetails?.id, id]);

  useEffect(() => {
    if (edufinData && id) {
      // const finalData=edufinData?.find((d:any)=>d?.id===id)
      const {
        bankDetail,
        contactDetail,
        courseDetail,
        instituteDetail,
        instituteInfo,
      } = edufinData?.[0]?.loanApplicationData;

      setInstituteInfo({
        instituteName: instituteDetail?.instituteName,
        // branchId: instituteDetail?.branchId,
        // branchName: instituteDetail?.branchName,
        branches: instituteDetail?.branches,
        address: instituteDetail?.address,
        city: instituteDetail?.city,
        state: instituteDetail?.state,
        pincode: instituteDetail?.pincode,
        operationSince: instituteDetail?.operationSince,
        averageFees: instituteDetail?.averageFees,
        studentStrength: instituteDetail?.studentStrength,
        teacherStrength: instituteDetail?.teacherStrength,
        affiliationCode: instituteDetail?.affiliationCode,
        instituteType: instituteDetail?.instituteType,
        board: instituteDetail?.board,
      });

      setContactInfo({
        principalName: contactDetail?.principalName,
        principalNumber: contactDetail?.principalNumber,
        spocPersonName: contactDetail?.spocPersonName,
        spocPersonNumber: contactDetail?.spocPersonNumber,
        spocPersonEmail: contactDetail?.spocPersonEmail,
        accountEmail: contactDetail?.accountEmail,
      });
      setBankInfo({
        bankName: bankDetail?.bankName,
        bankAccountNumber: bankDetail?.bankAccountNumber,
        ifscCode: bankDetail?.ifscCode,
        accountType: bankDetail?.accountType,
        beneficiaryName: bankDetail?.beneficiaryName,
        website: bankDetail?.website,
      });

      setInstituteInfoForCourse({
        instituteName: instituteInfo?.instituteName,
        instituteType: instituteInfo?.instituteType,
      });
      setCourses(
        courseDetail?.map((c: any, index: number) => ({
          id: index,
          courseName: c?.courseName || "",
          courseStartYear: c?.courseStartYear || "",
          duration: c?.duration || "",
          noOfStudents: c?.noOfStudents || 0,
          tutionFees: c?.tutionFees || 0,
          transportFees: c?.transportFees || 0,
          otherFees: c?.otherFees || 0,
          totalFees: c?.totalFees || 0,
        })) || [
          {
            id: 0,
            courseName: "",
            courseStartYear: "",
            duration: "",
            noOfStudents: 0,
            tutionFees: 0,
            transportFees: 0,
            otherFees: 0,
            totalFees: 0,
          },
        ]
      );
    }
  }, [edufinData, id, authUser]);

  return (
    <>
      <Box
        sx={{
          overflow: "hidden",
          padding: "14px 16px",
          background: "#EEEEEE",
          maxHeight: "calc(100vh - 65px)",
          position: "relative",
        }}
      >
        <Box
          sx={{
            // overflow: "scroll",
            background: "#fff",
            border: "1px solid #E9E9E9",
            borderRadius: "8px",
            // minHeight: "calc(100vh - 93px)",
            // maxHeight: "calc(100vh - 93px)",
          }}
        >
          <div
            className={styles.nurtureDetailsSplit}
            style={{
              minHeight: "calc(100vh - 93px)",
              maxHeight: "calc(100vh - 93px)",
            }}
          >
            <div className={styles.PageBackBtnWrap}>
              <button
                className={styles.PageBackBtn}
                onClick={() => navigate(`/app/Integrations`)}
              >
                <ArrowBackIcon
                  sx={{
                    marginRight: "8px",
                    fontSize: "15PX",
                    color: "#667085",
                  }}
                />
                Back
              </button>
              <div className={styles.edufinTitleSection}>
                <div className={styles.title}>
                  Education Loan Application Powered by EduFin
                </div>
                <div className={styles.subTitle}>
                  <img src={edufinLogo} />
                  Powered by EduFin
                </div>
              </div>
            </div>
            <div
              className={styles.nurtureDetailsSplitLeft}
              style={{
                width: "100%",
                overflow: "scroll",
                background: "#fff",
                // border: "1px solid #E9E9E9",
                // borderRadius: "8px",
                minHeight: "calc(100vh - 250px)",
                maxHeight: "calc(100vh - 250px)",
              }}
            >
              <div className={styles.progressIcon}>
                {/* <div
                  style={{
                    height: "80px",
                    width: "50px",
                  }}
                >
                  <div>
                    <img src={instituteDetailsImg} />
                  </div>
                  <div className={styles.iconName}>
                    Loan application details
                  </div>
                </div>

                <div className={styles.progressLine}></div>
                <div
                  style={{
                    height: "80px",
                    width: "50px",
                  }}
                >
                  <div>
                    {showIndex === 0 ? (
                      <img src={courseDetails} />
                    ) : (
                      <img src={activatedCourseDetails} />
                    )}
                  </div>
                  <div className={styles.iconName}>Course details</div>
                </div> */}
                {showIndex === 0 ? (
                  <img src={Inactive} height={100} />
                ) : (
                  <img src={Active} height={100} />
                )}
              </div>
              {showIndex === 0 ? (
                <InstituteDetailsForEdufin
                  setShowIndex={setShowIndex}
                  SaveEdufinData={SaveEdufinData}
                  saveEdufinSuccess={saveEdufinSuccess}
                  saveEdufinData={saveEdufinData}
                  edufinData={edufinData}
                  instituteInfo={instituteInfo}
                  setInstituteInfo={setInstituteInfo}
                  contactInfo={contactInfo}
                  setContactInfo={setContactInfo}
                  bankInfo={bankInfo}
                  setBankInfo={setBankInfo}
                />
              ) : (
                <CourseDetailsForEdufin
                  setShowIndex={setShowIndex}
                  SaveEdufinData={SaveEdufinData}
                  saveEdufinSuccess={saveEdufinSuccess}
                  saveEdufinData={saveEdufinData}
                  edufinData={edufinData}
                  courses={courses}
                  setCourses={setCourses}
                  instituteInfoForCourse={instituteInfoForCourse}
                  setInstituteInfoForCourse={setInstituteInfoForCourse}
                />
              )}
            </div>
          </div>
        </Box>
      </Box>
    </>
  );
}

export default EdufinDetails;
